goog.provide("shadow.js.shim.module$src$svg$artwork$not_found_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$not_found_svg");
shadow.js.shim.module$src$svg$artwork$not_found_svg = shadow.js.nativeProvides["src/svg/artwork/not-found.svg"] = shadow$bridge("src/svg/artwork/not-found.svg");
module$shadow_js_shim_module$src$svg$artwork$not_found_svg.default = shadow.js.shim.module$src$svg$artwork$not_found_svg;
